import React, { useEffect } from "react";
import { Form, Input, Modal, Row, Col } from "antd";

const WhatsNewForm = ({ visible, onCreate, onCancel, record, form }) => {
  // const [form] = Form.useForm();

  useEffect(() => {
    if (record) {
      // form.setFieldsValue(record);
      form.setFieldsValue({
        ...record,
      });
    } else {
      form.resetFields();
    }
  }, [record, form]);

  return (
    <Modal
      visible={visible}
      title={record ? "Update Whats New" : "Add Whats New"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            console.log("values :", values);
            onCreate(values);
            // form.resetFields();
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="whats_new_form"
        initialValues={record}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="feature"
              label="Feature"
              rules={[{ required: true, message: "Please input the feature!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="Date"
              label="Date"
              rules={[{ required: true, message: "Please choose date!" }]}
            >
              <Input type="date" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="link"
              label="link"
              rules={[
                { required: true, message: "Please input the link number!" },
              ]}
            >
              <Input type="text" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default WhatsNewForm;
